import { LocationStoreProvider } from '@/components/tabs/location-store-context';
import { Region } from '@/components/region';
import { readPageLocationName } from '@/lib/page-location';
import type { PageDesignerRouteData } from './types';

export function PageDesignerRoute({ data }: { data: PageDesignerRouteData }) {
    const locationName = readPageLocationName(data.page) ?? null;
    const parentLocationLabel = data.parentLocationLabel ?? null;

    return (
        <LocationStoreProvider store={null} locationName={locationName} parentLocationLabel={parentLocationLabel}>
            {data.page.regions?.map((region) => (
                <Region key={`${data.page.id}:${region.id}`} page={data.page} regionId={region.id} />
            ))}
        </LocationStoreProvider>
    );
}
